import React from "react";

const NavigationMyMessages = ({ onNewMessage }) => {
  const handleCreateMessage = () => {
    if (onNewMessage) {
      onNewMessage();
    }
  };

  return (
    <div className="">
      <div className="desktop:flex desktop:flex-row desktop:items-center">
        <div className="mobile:py-2 mobile:px-4 desktop:p-0">
          <div className="flex gap-2 mobile:justify-between">
            <h6 className="text-dark4 text-h6 mobile:text-bodyLM cursor-pointer">My messages</h6>
          </div>
        </div>

        {/* Action Button - Desktop */}
        <div className="hidden md:flex mobile:p-0 mobile:pr-4 mobile:justify-end mobile:bg-gray2 rounded-lg desktop:ml-auto desktop:p-4">
          <button
            onClick={handleCreateMessage}
            className="flex items-center gap-3 bg-primary text-white px-6 pl-4 py-2 rounded-lg hover:bg-opacity-90 transition-all"
          >
            <span className="text-xl">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M9 0.75C9.19891 0.75 9.38968 0.829018 9.53033 0.96967C9.67098 1.11032 9.75 1.30109 9.75 1.5V8.25H16.5C16.6989 8.25 16.8897 8.32902 17.0303 8.46967C17.171 8.61032 17.25 8.80109 17.25 9C17.25 9.19891 17.171 9.38968 17.0303 9.53033C16.8897 9.67098 16.6989 9.75 16.5 9.75H9.75V16.5C9.75 16.6989 9.67098 16.8897 9.53033 17.0303C9.38968 17.171 9.19891 17.25 9 17.25C8.80109 17.25 8.61032 17.171 8.46967 17.0303C8.32902 16.8897 8.25 16.6989 8.25 16.5V9.75H1.5C1.30109 9.75 1.11032 9.67098 0.96967 9.53033C0.829018 9.38968 0.75 9.19891 0.75 9C0.75 8.80109 0.829018 8.61032 0.96967 8.46967C1.11032 8.32902 1.30109 8.25 1.5 8.25H8.25V1.5C8.25 1.30109 8.32902 1.11032 8.46967 0.96967C8.61032 0.829018 8.80109 0.75 9 0.75Z"
                  fill="white"/>
              </svg>
            </span>
            New message
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavigationMyMessages;